<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid" />Tournament : <span class="font-weight-bold"> {{tournament.name}} </span>
      </slot>
      <div class="float-right">
        <router-link :to="{ name: 'QuestionCreate'}">
          <button class="btn btn-success m-1">Create Question</button>
        </router-link>
      </div>
    </CCardHeader>
    <CCardBody>
      <v-client-table :data="questions" :columns="columns" :options="options">
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'QuestionEdit', params: {id: props.row.id}}">
              <span
                  class="btn btn-warning btn-sm m-1"
                  data-toggle="tooltip"
                  title="Edit"
                  :href="props.row.id"
              >
                <CIcon name="cil-pencil" size="sm" />
              </span>
            </router-link>
            <span @click="handleDelete(props.row.id)"
                  class="btn btn-danger btn-sm m-1"
                  data-toggle="tooltip"
                  title="Delete"
                  :href="props.row.id"
            >
                <CIcon name="cil-basket" size="sm" />
              </span>
          </div>
        </template>
      </v-client-table>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "TournamentQuestions",
  data() {
    return {
      tournament: {},
      questions: [],
      selected_category: '',
      selected_topic: '',
      categories: [{ value: 0, label: 'Select Category'}],
      topics: [{ value: 0, label: 'Select Topic'}],
      columns: ["id", "english", "type", "action"],
      options: {
        headings: {
          english: 'Question'
        },
        pagination: { nav: "fixed" },
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    this.getQuestions();
  },
  methods: {
    getQuestions() {
      this.$axios
          .post(`${ADMIN_URL}/tournaments/questions`,{
              tournament_id : this.$route.params.id
          })
          .then((response) => {
            this.questions = response.data.questions;
            this.tournament = response.data.tournament;
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    handleDelete(id) {
      // console.log('handleDelete  category_id === ', category_id);
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      }).then(result => {
        if(result.value) {
          this.deleteQuestion(id);
        }
      }).catch(error => {
        //console.log('Sweetalert ERROR');
      });
    },
    deleteQuestion(id)
    {
      this.$axios
          .delete(`${ADMIN_URL}/questions/${id}`)
          .then((response) => {
            this.$swal("Success", response.data.message, "success");
            this.getQuestions()
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            this.$swal("Error", error.response.message, "error");
          });
    }
  },
};
</script>
